import { gql } from "@apollo/client";

// Raw gql against JBM-custom backend types (myNotifications) not in the base
// Saleor schema. Excluded from codegen in codegen-main.ts.
export const NOTIFICATIONS_QUERY = gql`
  query AdminNotifications($first: Int) {
    myNotifications(first: $first) {
      id
      type
      title
      message
      link
      isRead
      createdAt
    }
    myUnreadNotificationCount
  }
`;

export const UNREAD_NOTIFICATION_COUNT_QUERY = gql`
  query AdminUnreadNotificationCount {
    myUnreadNotificationCount
  }
`;
